import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import LandingPage from './components/LandingPage/LandingPage';
import PracticePage from './components/PracticePage/PracticePage';
import SettingsPage from './components/SettingsPage/SettingsPage';
import { GameProvider } from './contexts/GameContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { MidiProvider } from './contexts/MidiContext';
import { UserProvider } from './contexts/UserContext';
import { VirtualKeyboardProvider } from './contexts/VirtualKeyboardContext';
import { initGA } from './utils/analytics';
import { useRouteTracking } from './hooks/useRouteTracking';

// Component to handle route tracking
const RouteTracker = () => {
  useRouteTracking();
  return null;
};

function App() {
  useEffect(() => {
    // Initialize Google Analytics
    initGA();
  }, []);

  return (
    <UserProvider>
      <SettingsProvider>
        <Router>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/settings" element={<SettingsPage />} />

            <Route
              path="/practice"
              element={
                <MidiProvider>
                  <VirtualKeyboardProvider>
                    <GameProvider>
                      <PracticePage />
                    </GameProvider>
                  </VirtualKeyboardProvider>
                </MidiProvider>
              }
            />
          </Routes>
        </Router>
      </SettingsProvider>
    </UserProvider>
  );
}

export default App;
